/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { mixins, variables } from '@blend/consumer-components';

const styles = StyleSheet.create({
  label: {
    fontSize: 14,
    ...mixins.margin(0, 6, 0, variables.globalBorderRadius),
  },
});

export namespace ContentWrapper {
  export interface Props extends React.HTMLAttributes<HTMLLabelElement> {
    htmlFor: string;
  }
}

export const ContentWrapper: React.SFC<ContentWrapper.Props> = ({ htmlFor, children, ...htmlProps }) => {
  return (
    <label htmlFor={htmlFor} className={css(styles.label)} {...htmlProps}>
      {children}
    </label>
  );
};
